import { render, staticRenderFns } from "./imgUpload.vue?vue&type=template&id=3068ced2&scoped=true&"
import script from "./imgUpload.vue?vue&type=script&lang=js&"
export * from "./imgUpload.vue?vue&type=script&lang=js&"
import style0 from "./imgUpload.vue?vue&type=style&index=0&id=3068ced2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3068ced2",
  null
  
)

export default component.exports